"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBanner = void 0;
const collapsible_section_1 = __importDefault(require("../../ui/collapsible-section/collapsible-section"));
const initBanner = ($seo) => {
    new collapsible_section_1.default($seo.querySelector('.collapsible-section'));
};
exports.initBanner = initBanner;
